export default __webpack_public_path__ + "static/andersonlake-54af57fd5053d49557c7160b09cf8bf1.jpg";